import React, { useState, useEffect } from "react";
import "./About.css";
import { useNavigate } from "react-router-dom";
import lawImage from "./media/law.jpg";
import logo from "./media/logo.png";
import QRCode from "./media/qr_code.svg";

const NAV_ITEMS = [
  { label: "About Us", path: "/about", type: "page" },
  { label: "Our Team", path: "/team", type: "page" },
  { label: "Services", path: "/#services", type: "scroll" },
  { label: "Contact", path: "/contact", type: "page" }
];

function About() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (item) => {
    setMenuOpen(false);
    if (item.type === "scroll") {
        navigate("/");
        setTimeout(() => {
            const el = document.querySelector(item.path.replace("/", ""));
            if (el) el.scrollIntoView({ behavior: "smooth" });
        }, 100);
    } else {
        navigate(item.path);
        window.scrollTo(0, 0);
    }
  };

  return (
    <div className="App about-page-wrapper">
      <div className={`dimming-overlay ${menuOpen ? "active" : ""}`} onClick={() => setMenuOpen(false)}></div>

      {/* Header */}
      <header className={`App-header ${scrolled ? "scrolled" : ""}`}>
        <a className="logo" href="/" onClick={(e) => { e.preventDefault(); navigate("/"); }}>
          <img src={logo} alt="Logo" className="header-logo" />
        </a>
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="bar"></div><div className="bar"></div><div className="bar"></div>
        </div>
      </header>

      {/* Nav */}
      <nav className={`dropdown-menu ${menuOpen ? "open" : ""}`}>
        <ul>
          {NAV_ITEMS.map((item, index) => (
            <li className="dropdown-item" key={index}>
              <a onClick={() => handleNav(item)}>{item.label}</a>
            </li>
          ))}
        </ul>
      </nav>

      {/* Hero */}
      <section className="about-hero" style={{ backgroundImage: `url(${lawImage})` }}>
        <div className="about-hero-overlay">
          <h1>About The Firm</h1>
          <div className="custom-divider"></div>
        </div>
      </section>

      {/* Intro */}
      <section className="about-section white-bg">
        <div className="about-container">
          <div className="lead-text">
            <p>Merkel & Associates Advocates was founded with a vision to provide exceptional legal services. We have grown into a leading law firm in Kenya, renowned for our commitment to excellence, innovation, and client satisfaction.</p>
          </div>
          <div className="about-grid">
            <div className="about-card">
              <h3>Excellence</h3>
              <p>Delivering the highest standard of legal services.</p>
            </div>
            <div className="about-card">
              <h3>Innovation</h3>
              <p>Adopting innovative strategies to meet evolving needs.</p>
            </div>
            <div className="about-card">
              <h3>Client-Centric</h3>
              <p>Our clients are at the heart of everything we do.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="about-section gray-bg">
        <div className="about-container split-layout">
          <div className="text-box">
            <h2>Our Mission</h2>
            <p>To deliver effective and professional legal services with integrity, ensuring our clients receive the highest standard of representation.</p>
          </div>
          <div className="text-box">
            <h2>Our Philosophy</h2>
            <p>We are committed to providing value for money. We invest time to understand our clients, their businesses, and their goals.</p>
          </div>
        </div>
      </section>

      {/* Strategy */}
      <section className="about-section white-bg">
        <div className="about-container text-center">
          <h2>Strategic Theme</h2>
          <div className="custom-divider mx-auto"></div>
          <ul className="strategy-list">
            <li>Provide accessible, dependable, and timely services.</li>
            <li>Be fair, respectful, and transparent.</li>
            <li>Continuously improve our legal service delivery.</li>
          </ul>
        </div>
      </section>

      <footer className="App-footer">
        <p>© 2025 MERKEL & ASSOCIATES ADVOCATES.</p>
      </footer>
    </div>
  );
}

export default About;